export class FormControl {
  /**
   *
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.element = element
    this.regexp = false
    this.element.addEventListener('blur', this.style.bind(this))
    this.element.addEventListener('change', this.style.bind(this))
  }
  valid() {
    if (!this.element.required && this.element.value === '') return true
    if (this.element.validity.valid === false) {
      return false
    }
    if (this.element.required && !this.element.value) {
      console.warn(`${this.element.id} invalid value empty`)
      return false
    }
    if (this.regexp) {
      const regState = this.regexp.test(this.element.value)
      if (!regState) {
        console.warn(
          `${this.element.id} invalid no match regexp ${this.regexp} with value: ${this.element.value}`
        )
      }
      return regState
    }
    return true
  }
  style() {
    this.element.classList.toggle('is-invalid', !this.valid())
  }
}

export class FormControlEmail extends FormControl {
  constructor(element) {
    super(element)
    this.regexp = new RegExp(/\S+@\S+\.\S+/)
  }
}

export class FormControlPhone extends FormControl {
  constructor(element) {
    super(element)
    this.regexp = new RegExp(/\d{3} \d{3}-\d{4}/)
  }
}
